import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmptyReqFilter, JobTypeOptions, ReqPriorityOptions, ReqTermOptions, ReqTypeOptions, TReqFilter } from "./modal";
import { TDropdown } from "../../shared/modal";
import { Fetch } from "../../utilities/fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";

interface IProps {
    filters: TReqFilter,
    setFilters: (filters: TReqFilter) => void,
    loading: boolean,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    id: yup.number().nullable(),
    reqType: yup.number().nullable(),
    term: yup.number().nullable(),
    priority: yup.number().nullable(),
    jobType: yup.number().nullable(),
    industryId: yup.number().nullable(),
    skillCategoryId: yup.number().nullable(),
    interviewProcessId: yup.number().nullable(),
    noOfPositions: yup.number().nullable(),
});

export const Filter = (props: IProps) => {
    const [industries, setIndustries] = useState<Array<TDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<TDropdown>>();
    const [interviewProcess, setInterviewProcess] = useState<Array<TDropdown>>();

    const { control, handleSubmit, reset } = useForm<TReqFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadIndustries = async () => {
        const data = await Fetch<TDropdown[]>("dropdown/industries");
        if (data) {
            setIndustries(data);
        }
    }
    const loadInterviewProcess = async () => {
        const data = await Fetch<TDropdown[]>("dropdown/interviewProcess");
        if (data) {
            setInterviewProcess(data);
        }
    }
    const loadSkillCategories = async () => {
        const data = await Fetch<TDropdown[]>("dropdown/skillCategories");
        if (data) {
            setSkillCategories(data);
        }
    }

    useEffect(() => {
        loadIndustries();
        loadSkillCategories();
        loadInterviewProcess();
    }, []);

    const onSubmit = (data: TReqFilter) => {
        props.setFilters(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate column={4} label="From Date" control={control} name="fromDate" />
            <JVDate column={4} label="To Date" control={control} name="toDate" />

            <JVInput column={4} type="number" label="Req Id" control={control} name="id" />
            <JVDropdown column={4} required label="Req Type" control={control} name="reqType"
                options={ReqTypeOptions} optionLabel="name" optionValue="id" placeholder="Select req type" />

            <JVDropdown column={4} required label="No of Positions" control={control} name="noOfPositions"
                options={[{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 },
                { id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 }, { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }, { id: 20 }
                ]} optionLabel="id" optionValue="id" placeholder="Select no of positions" />

            <JVDropdown column={4} required label="Priority" control={control} name="priority"
                options={ReqPriorityOptions} optionLabel="name" optionValue="id" placeholder="Select priority" />

            <JVDropdown column={4} required label="Job Type" control={control} name="jobType"
                options={JobTypeOptions} optionLabel="name" optionValue="id" placeholder="Select job type" />
            <JVDropdown column={4} required label="Term" control={control} name="term"
                options={ReqTermOptions} optionLabel="name" optionValue="id" placeholder="Select term" />

            <JVDropdown column={4} required label="Industry" control={control} name="industryId"
                options={industries} optionLabel="name" optionValue="id" placeholder="Select industry" />
            <JVDropdown column={4} required label="Skill Category" control={control} name="skillCategoryId"
                options={skillCategories} optionLabel="name" optionValue="id" placeholder="Select skill category" />
            <JVDropdown column={4} required label="Interview Process" control={control} name="interviewProcessId"
                options={interviewProcess} optionLabel="name" optionValue="id" placeholder="Select interview process" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset(EmptyReqFilter)} type="button"></Button>
            </div>
        </form>
    );
}